import BpkButton, {
  BUTTON_TYPES,
} from '@skyscanner-internal/backpack-web/bpk-component-button';
import BpkLargeExclamationCircleIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/exclamation-circle';
import BpkPanel from '@skyscanner-internal/backpack-web/bpk-component-panel';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import classNames from 'classnames';

import STYLES from './FlightListStatus.module.scss';

interface FlightListStatusProps {
  buttonText?: string;
  message: string;
  onButtonClick?: () => void;
  error?: boolean;
}

const FlightListStatus = ({
  buttonText = undefined,
  error = false,
  message,
  onButtonClick = undefined,
}: FlightListStatusProps) => (
  <BpkPanel className={STYLES.FlightListStatus}>
    <div className={STYLES.FlightListStatus__containerStatusIcon}>
      <BpkLargeExclamationCircleIcon
        className={classNames(STYLES.FlightListStatus__statusIcon, {
          [STYLES['FlightListStatus__statusIcon--error']]: error,
        })}
      />
    </div>
    <BpkText
      tagName="p"
      textStyle={TEXT_STYLES.label1}
      className={STYLES.FlightListStatus__statusText}
    >
      {message}
    </BpkText>
    {buttonText && (
      <BpkButton
        className={STYLES.FlightListStatus__button}
        onClick={onButtonClick}
        type={BUTTON_TYPES.secondary}
      >
        {buttonText}
      </BpkButton>
    )}
  </BpkPanel>
);

export default FlightListStatus;
